// NO EDITAR A MANO
// const id = "footer.link_apps.download-android";
const valor = `Download Free Android App Meteored`;

export default valor;
